import { Component, OnInit } from '@angular/core';
import { TagService } from './shared/tag.service';
import {AlertService} from '../shared/alert.service';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {
  entity = 'tag';
  title = 'Etiqueta';
  tags = {};
  tagsReady = false;
  actions = true;
  columns = [
    ['name', 'Nombre'],
    ['section', 'Sección']
  ];
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];
  hasDataTables = false;
  prevPath = '/tag/';
  msg = {
    'deleteSuccess': 'Etiqueta borrada con éxito',
    'deleteError': 'Hubo un error al borrar etiqueta'
  };
  pagination = 25;
  offset = 0;

  constructor(private tagService: TagService,
              private alertService: AlertService) {
  }

  ngOnInit() {
    this.getAllTags();
  }

  getAllTags() {
    this.tagService.getAllTags(this.pagination, this.offset)
      .subscribe(
        tagsResponse => {
          this.tags = tagsResponse;
          this.tagsReady = true;
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  setLimit(value) {
    this.pagination = +value;
    this.getAllTags();
  }

  setOffset(value) {
    this.offset = +value;
    this.getAllTags();
  }

  delete(id) {
    if (id) {
      this.tagService.deleteTag(id)
        .subscribe(
          tagsResponse => {
            if (tagsResponse === 1) {
              for (let element = 0; element < this.tags['objects'].length; element++) {
                if (this.tags['objects'][element]['id'] === id) {
                  this.tags['objects'].splice(element, 1);
                  break;
                }
              }
            }
            this.tagsReady = true;
            this.alertService.success(this.msg['deleteSuccess']);
          },
          error => {
            this.alertService.error(this.msg['deleteError']);
          }
        );
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/tags/tag.component.ts